//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    props: {
        building_id: {
            type: [String, Number]
        },
        coupons: {
            type: Array
        }
    },
    computed: {
        url () {
            return `/pages/building/coupons/main?building_id=${this.building_id}`
        }
    }
}
